import styled, { css } from 'styled-components';
import { DocumentStatus } from '../../../services/documents';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  padding: 32px;
  gap: 32px;
  background: #f8fbfa;
  font-family: 'Manrope', sans-serif;

  .top-menu {
    display: none;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 16px;
    gap: 16px;

    .top-menu {
      display: block;
      z-index: 20;

      svg {
        width: 34px;
        height: 34px;
        color: #3d3d3d;
      }
    }
  }
`;

export const Main = styled.main`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  width: 100%;
  padding: 25px 30px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fefefede;
  border-radius: 20px;
  color: #3d3d3d;

  p {
    font-weight: bold;
    font-size: 14px;
    color: #989898;
  }

  .missing {
    font-size: 14px;
    color: #c98a00;
  }
`;

export const Card = styled.section`
  width: 100%;
  padding: 27px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fefefede;
  border-radius: 20px;
  color: #3d3d3d;

  .card-header {
    display: flex;
    flex-direction: column;
    gap: 4px;

    p {
      font-weight: bold;
      font-size: 12px;
      color: #989898;
    }
  }
`;

export const FileRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 12px 16px;
  border-radius: 12px;
  background: #f5f5f5;
  font-size: 14px;

  .file-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
  }

  .rejection {
    width: 100%;
    order: 3;
    font-size: 12px;
    color: #cd5656;
  }

  .file-actions {
    display: flex;
    gap: 8px;

    button {
      display: flex;
      align-items: center;
      gap: 4px;
      border: none;
      background: transparent;
      font-size: 12px;
      font-weight: bold;
      color: #3d3d3d;
      cursor: pointer;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      svg {
        width: 16px;
        height: 16px;
        color: inherit;
      }
    }
  }
`;

const statusColors: Record<DocumentStatus, string> = {
  pending: '#c98a00',
  approved: '#1f9a3f',
  rejected: '#cd5656',
};

export const Status = styled.span<{ status: DocumentStatus }>`
  ${({ status }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: bold;
    color: ${statusColors[status]};

    svg {
      width: 16px;
      height: 16px;
      color: ${statusColors[status]};
    }
  `}
`;

export const UploadButton = styled.label<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    align-self: flex-start;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px dashed ${theme.colors['blue-shade-400']};
    color: ${theme.colors['blue-shade-400']};
    font-size: 14px;
    font-weight: bold;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    opacity: ${disabled ? 0.6 : 1};

    svg {
      width: 18px;
      height: 18px;
      color: inherit;
    }

    input {
      display: none;
    }
  `}
`;
